<h2 mat-dialog-title>{{data.title}}</h2>
<mat-dialog-content>
  @if(visible){
  <div>
    @if(isJson){
    @if(isJson){
    <div class="jk-grid-cols-2">
      <mat-select [(ngModel)]="bookTypeItem" matTooltip="格式" placeholder="匯出格式">
        @for(idNameItem of bookTypeList; track idNameItem) {
        <mat-option [value]="idNameItem">{{idNameItem.name}}</mat-option>
        }
      </mat-select>
      <button (click)="doExport()" class="btn-primary">匯出</button>
      <!-- <app-jkcombobox  [styleDisplay]="'flex'" label="匯出格式" [(value)]="bookType" [items]="bookTypeList">
         </app-jkcombobox> -->
    </div>
    }

    <pre>{{ jsonObj | json }}</pre>
    }
    @if(!isAbout){
    <div>
      <!-- <app-jktextarea [height]="'600px'" [(value)]="value" [readOnly]="false">
      </app-jktextarea> -->
      <textarea matImput class="jk-textarea-area" [rows]="rows" [hidden]="!visible" [disabled]="disabled"
        [(value)]="value"
        [ngStyle]="{'min-height': minHeight + 'px', 'max-height': maxHeight + 'px', 'height': height }"
        [readOnly]="false" [placeholder]="label">
    </textarea>

    </div>
    }
    @if(isAbout){
    <div>
      <textarea matImput class="jk-textarea-area" [rows]="rows" [hidden]="!visible" [disabled]="disabled"
        [(value)]="platformValue"
        [ngStyle]="{'min-height': minHeight + 'px', 'max-height': maxHeight + 'px', 'height': height }"
        [readOnly]="false" [placeholder]="label">
    </textarea>
    </div>
    }
  </div>
  }
</mat-dialog-content>
<mat-dialog-actions>
  <button cdkFocusInitial
    (click)="onNoClick(true)" class="btn-primary">確定</button>
  <button (click)="onNoClick(false)" class="btn-warning">取消</button>
  <button (click)="doCopy()" class="btn-neutral">複製</button>
</mat-dialog-actions>
